import config from '../config.js'

export function getUrl(resource) {
    return config.baseUrl + resource
}



// WEBPACK FOOTER //
// ./src/services/get-url.js